export default __webpack_public_path__ + "static/media/SwamijiNew2.9ebcbe61.JPG";